// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3VezC","header":"MergedInvoice_header__12r1I"};